// import { useIsInView } from '@ddg-frontend/blocks/hooks'
import { useIsProgramRecording } from '../../hooks/useIsProgramRecording'
import { Channel, Program } from '../../types'
import { RecordDot, RecordDots } from '../program-drawer-components/record-dots'
import { getResource } from '../../utils'

export const ProgramItem = ({
  program,
  channel,
  day,
  onProgramClick,
  isLastProgram = false,
}: {
  program: Program
  channel: Channel
  day: string
  onProgramClick: (
    id: number | undefined,
    channel: Channel | undefined,
    date?: string | undefined
  ) => void
  isLastProgram?: boolean
}) => {
  const minutePx = 200 / 30

  const { data } = useIsProgramRecording(program.programId || 0)
  const duration = isLastProgram ? program.totalDuration : program.duration
  const currentDate = new Date()
  const isHappeningNow =
    program.start.date <= currentDate && program.end.date >= currentDate
  // const [viewRef, isInView] = useIsInView<HTMLLIElement>({
  //   rootMargin: '0px',
  //   threshold: 0.01,
  // })
  if (duration === 0) {
    return null
  }
  const width = duration * minutePx - 6
  return (
    <li
      key={program.id}
      className={`program-item ${channel.isAdult ? 'adult' : ''} ${
        isLastProgram ? 'is-last' : ''
      } ${isHappeningNow ? 'is-now' : ''}`}
      style={{
        width: `${width}px`,
      }}
      onClick={() => {
        if (!channel.isAdult) onProgramClick(program.id, channel, day)
      }}
      // ref={viewRef}
    >
      <button
        // tabIndex={isInView ? 0 : -1}
        type="button"
        className="program-item-inner"
        style={{
          padding: width > 24 ? '12px' : '0',
        }}
      >
        <div className="program-item-content">
          <div className="title-label ">
            {channel.isAdult ? (
              <span>{getResource('Program.AdultContent')}</span>
            ) : (
              <span className="no-translate">{program.title}</span>
            )}
            {data === 'everyday' && <RecordDots />}
            {data === 'once' && <RecordDot />}
          </div>
          <div className="time-label">
            {program.start.time} - {program.end.time}
          </div>
        </div>
        {!channel.isAdult && <span className="icon-adicionar program-icon" />}
      </button>
    </li>
  )
}
